export default 'Please enter a valid birthday'
